import { render } from "./defaultHotspot.vue?vue&type=template&id=ccd38962"
import script from "./defaultHotspot.vue?vue&type=script&lang=js"
export * from "./defaultHotspot.vue?vue&type=script&lang=js"

import "./defaultHotspot.vue?vue&type=style&index=0&id=ccd38962&lang=scss"

import exportComponent from "C:\\Users\\chbo\\Documents\\repos\\semco-maritime-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__